export const getConversationsCursor = (state) =>
  state.conversations.fetchCursor;

export const getConversations = (state) => state.conversations.conversations;
